import { ExameRealizadoPreNatalConsolidadoStatusEnum } from 'graphql/types.generated'

export const labelByStatus = (status?: ExameRealizadoPreNatalConsolidadoStatusEnum): string =>
  status ? statusToText[status] : statusInvalidoText

const statusToText: Record<ExameRealizadoPreNatalConsolidadoStatusEnum, string> = {
  [ExameRealizadoPreNatalConsolidadoStatusEnum.SIM]: 'Sim',
  [ExameRealizadoPreNatalConsolidadoStatusEnum.NAO]: 'Não',
  [ExameRealizadoPreNatalConsolidadoStatusEnum.NAO_SE_APLICA]: 'Não se aplica',
}

const statusInvalidoText = '-'
